import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { FormBannedActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function FormBanned({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as FormBannedActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return (
    <ItemWrapper notification={notification}>
      《{formInfo.formName}》{activity.content}
    </ItemWrapper>
  )
}
